<template>
  <section class="eva-page">
    <v-row>
      <v-col cols="12" offset="0" md="10" offset-md="1">

        <!-- TOPO -->
        <div class="eva-top">
          <v-breadcrumbs
            large
            :items="crumbs"
            divider="/"
            class="pl-0 eva-breadcrumbs"
          />

          <div class="eva-titlebar">
            <div class="eva-title">
              <v-icon color="primary" class="mr-2">
                mdi-file-document-multiple-outline
              </v-icon>

              <span class="primary--text">
                Formulários de Formação
              </span>
            </div>
          </div>
        </div>


        <!-- CARD PRINCIPAL -->
        <v-card
          class="eva-card mt-6"
          elevation="10"
        >
          <v-card-title
            class="eva-card__title primary white--text"
          >
            <div class="d-flex align-center">
              <v-icon
                class="mr-2"
                color="white"
              >
                mdi-form-select
              </v-icon>

              <span class="font-weight-bold">
                Formulários
              </span>
            </div>

            <v-spacer />

            <v-chip
              color="white"
              outlined
              class="eva-chip"
            >
              <v-icon left small>
                mdi-format-list-bulleted
              </v-icon>

              {{ total }} registos
            </v-chip>
          </v-card-title>


          <v-card-text class="pt-6">

            <!-- FILTROS -->
            <v-row
              class="mb-3"
              align="center"
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="filter.search"
                  label="Pesquisar"
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  dense
                  clearable
                  hide-details
                  @keyup.enter="searchFormularios({ type: 'submit' })"
                  @click:clear="clearSearch"
                />
              </v-col>

              <v-col
                cols="12"
                md="3"
              >
                <v-select
                  v-model="filter.is_active"
                  :items="statusOptions"
                  label="Estado"
                  item-text="text"
                  item-value="value"
                  outlined
                  dense
                  clearable
                  hide-details
                  @change="onFilterChange"
                />
              </v-col>

              <v-col
                cols="12"
                md="3"
                class="d-flex justify-end"
              >
                <v-btn
                  text
                  small
                  class="mr-2"
                  @click="resetFormularios"
                >
                  <v-icon left small>
                    mdi-filter-remove
                  </v-icon>

                  Limpar
                </v-btn>

                <v-btn
                  color="primary"
                  small
                  @click="searchFormularios({ type: 'submit' })"
                >
                  <v-icon left small>
                    mdi-magnify
                  </v-icon>

                  Procurar
                </v-btn>
              </v-col>
            </v-row>


            <!-- TABELA -->
            <div style="position: relative">
              <v-data-table
                :headers="headers"
                :items="items"
                :server-items-length="total"
                :loading="loading"
                :footer-props="tableFooter"
                :options.sync="options"
                class="eva-table"
                locale="pt-pt"
                disable-sort
              >

                <!-- HEADER TABELA -->
                <template v-slot:top>
                  <div
                    class="d-flex align-center justify-space-between px-4 py-2"
                  >
                    <div
                      class="text-subtitle-1 font-weight-bold"
                    >
                      Formulários
                    </div>

                    <v-btn
                      color="primary"
                      small
                      @click="createFormulario"
                    >
                      <v-icon left>
                        mdi-plus
                      </v-icon>

                      Adicionar
                    </v-btn>
                  </div>
                </template>


                <!-- SORT: NOME -->
                <template v-slot:header.nome>
                  <span
                    class="sortable-header"
                    @click="toggleSort('nome')"
                  >
                    Nome

                    <v-icon small>
                      {{ getSortIcon("nome") }}
                    </v-icon>
                  </span>
                </template>


                <!-- SORT: CÓDIGO -->
                <template v-slot:header.codigo>
                  <span
                    class="sortable-header"
                    @click="toggleSort('codigo')"
                  >
                    Código

                    <v-icon small>
                      {{ getSortIcon("codigo") }}
                    </v-icon>
                  </span>
                </template>


                <!-- SORT: CAMPOS -->
                <template v-slot:header.campos_count>
                  <span
                    class="sortable-header"
                    @click="toggleSort('campos_count')"
                  >
                    Campos

                    <v-icon small>
                      {{ getSortIcon("campos_count") }}
                    </v-icon>
                  </span>
                </template>


                <!-- SORT: FORMAÇÕES -->
                <template v-slot:header.formacoes_count>
                  <span
                    class="sortable-header"
                    @click="toggleSort('formacoes_count')"
                  >
                    Formações

                    <v-icon small>
                      {{ getSortIcon("formacoes_count") }}
                    </v-icon>
                  </span>
                </template>


                <!-- SORT: ESTADO -->
                <template v-slot:header.is_active>
                  <span
                    class="sortable-header"
                    @click="toggleSort('is_active')"
                  >
                    Estado

                    <v-icon small>
                      {{ getSortIcon("is_active") }}
                    </v-icon>
                  </span>
                </template>


                <!-- SORT: CRIADO -->
                <template v-slot:header.created_at>
                  <span
                    class="sortable-header"
                    @click="toggleSort('created_at')"
                  >
                    Criado em

                    <v-icon small>
                      {{ getSortIcon("created_at") }}
                    </v-icon>
                  </span>
                </template>


                <!-- NOME -->
                <template v-slot:item.nome="{ item }">
                  <div class="d-flex align-center">
                    <v-icon
                      small
                      color="primary"
                      class="mr-2"
                    >
                      mdi-form-select
                    </v-icon>

                    <span class="font-weight-medium">
                      {{ item.nome || "—" }}
                    </span>
                  </div>
                </template>


                <!-- CÓDIGO -->
                <template v-slot:item.codigo="{ item }">
                  <v-chip
                    small
                    outlined
                    color="primary"
                  >
                    {{ item.codigo || "—" }}
                  </v-chip>
                </template>


                <!-- DESCRIÇÃO -->
                <template v-slot:item.descricao="{ item }">
                  <span
                    v-if="item.descricao"
                    class="descricao-text"
                  >
                    {{ item.descricao }}
                  </span>

                  <span v-else>
                    —
                  </span>
                </template>


                <!-- CAMPOS -->
                <template v-slot:item.campos_count="{ item }">
                  <v-chip
                    small
                    color="blue-grey lighten-5"
                    text-color="blue-grey darken-3"
                  >
                    <v-icon
                      left
                      small
                    >
                      mdi-form-textbox
                    </v-icon>

                    {{ item.campos_count || 0 }}
                  </v-chip>
                </template>


                <!-- FORMAÇÕES ASSOCIADAS -->
                <template v-slot:item.formacoes_count="{ item }">
                  <v-chip
                    small
                    color="blue-grey lighten-5"
                    text-color="blue-grey darken-3"
                  >
                    <v-icon
                      left
                      small
                    >
                      mdi-school
                    </v-icon>

                    {{ item.formacoes_count || 0 }}
                  </v-chip>
                </template>


                <!-- ESTADO -->
                <template v-slot:item.is_active="{ item }">
                  <v-chip
                    small
                    :color="item.is_active ? 'success' : 'grey'"
                    dark
                  >
                    <v-icon
                      left
                      small
                    >
                      {{
                        item.is_active
                          ? "mdi-check-circle"
                          : "mdi-close-circle"
                      }}
                    </v-icon>

                    {{
                      item.is_active
                        ? "Ativo"
                        : "Inativo"
                    }}
                  </v-chip>
                </template>


                <!-- DATA -->
                <template v-slot:item.created_at="{ item }">
                  {{ getTableDate(item.created_at) }}
                </template>


                <!-- AÇÕES -->
                <template v-slot:item.actions="{ item }">
                  <v-row
                    align="center"
                    justify="center"
                    no-gutters
                  >
                    <v-col cols="auto">

                      <!-- VER / EDITAR -->
                      <v-tooltip top>
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            small
                            color="primary"
                            class="mr-3"
                            v-bind="attrs"
                            v-on="on"
                            @click="openFormulario(item)"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>

                        <span>
                          Editar formulário
                        </span>
                      </v-tooltip>


                      <!-- ELIMINAR -->
                      <IconRemove
                        v-if="
                          $store.getters.hasPermission([
                            'super',
                            'trainings.forms.create'
                          ])
                        "
                        class="mr-2"
                        @on-submit="deleteFormulario(item)"
                      />

                    </v-col>
                  </v-row>
                </template>


                <!-- SEM DADOS -->
                <template v-slot:no-data>
                  <div
                    class="pa-6 grey--text text--darken-1 text-center"
                  >
                    <v-icon
                      color="grey"
                      class="mb-2"
                    >
                      mdi-file-document-outline
                    </v-icon>

                    <div>
                      Sem formulários encontrados.
                    </div>
                  </div>
                </template>

              </v-data-table>
            </div>

          </v-card-text>
        </v-card>

      </v-col>
    </v-row>
  </section>
</template>

<script>
import Formacoes from "@/api/Formacoes.js";
import dayjs from "dayjs";
import IconRemove from "@/components/UI/IconRemove.vue";

export default {
  name: "Formularios",

  components: {
    IconRemove,
  },

  watch: {
    options: {
      handler() {
        if (this.skipOptionsWatch) {
          return;
        }

        setTimeout(() => {
          this.searchFormularios();
        }, 10);
      },

      deep: true,
    },
  },

  beforeCreate() {
    document.title = "ODC - Formulários de Formação";
  },

  data: () => ({
    headers: [
      {
        text: "Nome",
        sortable: false,
        value: "nome",
      },
      {
        text: "Código",
        sortable: false,
        value: "codigo",
      },
      {
        text: "Descrição",
        sortable: false,
        value: "descricao",
      },
      {
        text: "Campos",
        align: "center",
        sortable: false,
        value: "campos_count",
      },
      {
        text: "Formações",
        align: "center",
        sortable: false,
        value: "formacoes_count",
      },
      {
        text: "Estado",
        sortable: false,
        value: "is_active",
      },
      {
        text: "Criado em",
        sortable: false,
        value: "created_at",
      },
      {
        text: "Opções",
        align: "center",
        sortable: false,
        value: "actions",
      },
    ],

    items: [],

    total: 0,

    loading: false,

    searching: false,

    skipOptionsWatch: false,

    statusOptions: [
      {
        text: "Ativos",
        value: true,
      },
      {
        text: "Inativos",
        value: false,
      },
    ],

    tableFooter: {
      "items-per-page-options": [
        5,
        10,
        15,
        20,
      ],
      "items-per-page-text": "Linhas por página",
    },

    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },

    filter: {
      search: null,
      is_active: null,
    },
  }),

  computed: {
    crumbs() {
      return [
        {
          text: "Dashboard",
          disabled: false,
          to: "/admin",
          exact: true,
        },
        {
          text: "Formações",
          disabled: false,
          to: "/trainings",
          exact: true,
        },
        {
          text: "Formulários",
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    },
  },

  mounted() {
    if (
      !this.$store.getters.hasPermission([
        "super",
        "trainings.forms.create",
      ])
    ) {
      this.$router.push("/trainings");

      return;
    }

    this.fillBaseData();

    this.searchFormularios();
  },

  methods: {
    fillBaseData() {
      const userId =
        this.$store.state.user
        && this.$store.state.user.data
        ? this.$store.state.user.data.id
        : null;

      if (!userId) {
        return;
      }

      const key =
        "formacoes-formularios-list-" + userId;

      if (localStorage[key] !== undefined) {
        try {
          const data = JSON.parse(
            localStorage[key]
          );

          this.filter = data.filter || {
            search: null,
            is_active: null,
          };

          this.options = data.options || {
            page: 1,
            itemsPerPage: 10,
            sortBy: [],
            sortDesc: [],
          };
        } catch (error) {
          localStorage.removeItem(key);
        }
      }
    },


    saveBaseData() {
      const userId =
        this.$store.state.user
        && this.$store.state.user.data
        ? this.$store.state.user.data.id
        : null;

      if (!userId) {
        return;
      }

      const key =
        "formacoes-formularios-list-" + userId;

      localStorage[key] = JSON.stringify({
        filter: this.filter,
        options: this.options,
      });
    },


    searchFormularios(event) {
      if (
        event
        && event.type === "submit"
      ) {
        this.options.page = 1;
      }

      this.loading = true;

      const request = {
        page: this.options.page,

        limit:
          this.options.itemsPerPage,

        search:
          this.filter.search || null,

        is_active:
          this.filter.is_active,

        sortBy:
          this.getSortBy(),

        sortDesc:
          this.getSortDesc(),
      };

      this.saveBaseData();

      Formacoes.searchFormularios(request)
        .then((response) => {
          const data = response.data;

          this.total =
            data.total || 0;

          this.items =
            data.data || [];

          this.searching = false;
        })
        .catch(() => {
          this.items = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },


    onFilterChange() {
      this.options.page = 1;

      this.searchFormularios();
    },


    clearSearch() {
      this.filter.search = null;

      this.options.page = 1;

      this.searchFormularios();
    },


    resetFormularios() {
      this.skipOptionsWatch = true;

      this.filter = {
        search: null,
        is_active: null,
      };

      this.options = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      };

      this.$nextTick(() => {
        this.skipOptionsWatch = false;

        this.searchFormularios();
      });
    },


    toggleSort(column) {
      const currentSort =
        this.getSortBy();

      const currentDesc =
        this.getSortDesc();

      this.skipOptionsWatch = true;

      if (currentSort !== column) {
        this.options.sortBy = [
          column,
        ];

        this.options.sortDesc = [
          false,
        ];
      } else if (
        currentSort === column
        && currentDesc === 0
      ) {
        this.options.sortBy = [
          column,
        ];

        this.options.sortDesc = [
          true,
        ];
      } else {
        this.options.sortBy = [];

        this.options.sortDesc = [];
      }

      this.options.page = 1;

      this.$nextTick(() => {
        this.skipOptionsWatch = false;

        this.searchFormularios();
      });
    },


    getSortBy() {
      if (
        !this.options.sortBy
        || this.options.sortBy.length === 0
      ) {
        return null;
      }

      return this.options.sortBy[0];
    },


    getSortDesc() {
      if (
        !this.options.sortDesc
        || this.options.sortDesc.length === 0
      ) {
        return null;
      }

      return this.options.sortDesc[0]
        ? 1
        : 0;
    },


    getSortIcon(column) {
      const currentSort =
        this.getSortBy();

      if (currentSort !== column) {
        return "mdi-swap-vertical";
      }

      const currentDesc =
        this.getSortDesc();

      return currentDesc
        ? "mdi-arrow-down"
        : "mdi-arrow-up";
    },


    createFormulario() {
      this.$router.push(
        "/trainings/forms/create"
      );
    },


    openFormulario(item) {
      if (!item || !item.id) {
        return;
      }

      this.$router.push(
        "/trainings/forms/" + item.id
      );
    },


    deleteFormulario(item) {
      if (!item || !item.id) {
        return;
      }

      this.loading = true;

      Formacoes.deleteFormulario(item.id)
        .then(() => {
          /*
           * O backend pode:
           *
           * - eliminar fisicamente se nunca foi usado;
           * - ou apenas desativar se já tiver
           *   formações associadas.
           *
           * Em ambos os casos refrescamos
           * simplesmente a listagem.
           */
          this.searchFormularios();
        })
        .finally(() => {
          this.loading = false;
        });
    },


    getTableDate(date) {
      return date != null
        ? dayjs(date)
            .toDate()
            .toLocaleDateString()
        : "-";
    },
  },
};
</script>

<style scoped>
.eva-page {
  padding-bottom: 32px;
}

.eva-top {
  margin-top: 8px;
}

.eva-breadcrumbs :deep(.v-breadcrumbs__item) {
  font-size: 13px;
}

.eva-titlebar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
}

.eva-title {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.eva-card {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.eva-card__title {
  font-weight: 800;
  letter-spacing: 0.2px;
}

.eva-chip {
  border-radius: 999px;
}

.eva-table {
  border-radius: 14px;
  overflow: hidden;
}

.eva-table :deep(thead th) {
  font-weight: 800;
  color: rgba(0, 0, 0, 0.75);
  letter-spacing: 0.2px;
}

.eva-table :deep(tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
}

.sortable-header {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  user-select: none;
}

.sortable-header:hover {
  color: var(--v-primary-base);
}

.descricao-text {
  display: inline-block;
  max-width: 340px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>